import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../containers/Layout/Layout";
import {
  loadCompanyAction,
  saveCompanyAction,
  getCompany,
  isLoading,
  isSaving
} from "../../../state/trial";
import { loadLocationsAction, getLocations } from "../../../state/data";

import Loader from "../../atomic/Loader/Loader";
import RegisterCompany from "../../partials/RegisterCompany/RegisterCompany";

const RegisterCompanyPage = ({}) => {
  const company = useSelector(getCompany);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const saving = useSelector(isSaving);
  const locations = useSelector(getLocations);

  useEffect(() => {
    if (!company) {
      dispatch(loadCompanyAction());
    }
    if (!locations) {
      dispatch(loadLocationsAction());
    }
  }, []);
  if (!company || loading || !locations) {
    return <Loader />;
  }
  return (
    <Layout>
      <h1>Company details</h1>
      <RegisterCompany
        company={company}
        saving={saving}
        locations={locations}
        save={company => dispatch(saveCompanyAction(company))}
      />
    </Layout>
  );
};

export default RegisterCompanyPage;
